import React from 'react';
import { useTranslation } from 'react-i18next';
import { isGovCloudRegion } from '../utils';

import styles from '../c1c-header.module.css';

const ErrorHandler = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.error_page} role="alert">
      <div className={styles.error_icon} />
      <div className={styles.error_title}>{t('errorMessaging.title')}</div>
      <div className={styles.error_message}>
        {t('errorMessaging.message')}
        <a
          href={t(`errorMessaging.${isGovCloudRegion ? 'supportLinkGov' : 'supportLink'}`)}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('errorMessaging.linkedContent')}
        </a>
      </div>
    </div>
  );
};

export default ErrorHandler;
